var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99316 23.7516H13.3314C13.6852 23.7518 14.0245 23.6114 14.2748 23.3614C14.5248 23.1111 14.6652 22.7718 14.6649 22.418V17.0818C14.6652 16.728 14.5248 16.3887 14.2748 16.1384C14.0245 15.8884 13.6852 15.748 13.3314 15.7482L10.0002 15.7482",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 15.7482L26.67 15.7482C26.3162 15.748 25.9769 15.8884 25.7266 16.1384C25.4766 16.3887 25.3362 16.728 25.3364 17.0818V22.418C25.3362 22.7718 25.4766 23.1111 25.7266 23.3614C25.9769 23.6114 26.3162 23.7518 26.67 23.7516H30.0002",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3565 22.6481H24.4961C24.2099 22.6479 23.9271 22.7093 23.6668 22.8282L19.458 24.745",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6446 16.6666C18.1385 16.3652 17.5248 16.3036 16.9689 16.4985L14.668 17.3279",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4963 16.4345L22.6191 15.168C22.0025 14.8966 21.2907 14.9538 20.7253 15.3201L18.1142 17.0118C17.7218 17.2661 17.4698 17.6882 17.4319 18.1542C17.3941 18.6203 17.5749 19.0775 17.9211 19.3917V19.3917C18.3706 19.7988 19.0202 19.8969 19.5698 19.6409L21.1265 18.9145",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1266 18.9136L21.9169 19.6309C22.3341 20.0089 22.5728 20.5452 22.5743 21.1082C22.5758 21.6712 22.3401 22.2088 21.9249 22.5891L19.9071 24.4359C19.1454 25.133 17.9782 25.1361 17.2129 24.4429L15.8264 23.1853C15.4971 22.8926 15.0803 22.7168 14.6409 22.6851",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardIcon);
export default __webpack_public_path__ + "static/media/AwardIcon.94bcaf05f8fe4b027d7df89eda2d6b9d.svg";
export { ForwardRef as ReactComponent };